module.exports = __webpack_public_path__ + "img/ids_training.d7a5d970.png";